module.exports = __webpack_public_path__ + "img/client-start-quimica.66b2f913.jpg";